import { useMemo, useState } from 'react';
import debounce from 'lodash.debounce';
import { v4 as uuidv4 } from 'uuid';

import { axisGridColor, ticksColor } from './color';
import { externalTooltipHandler } from './createCustomTooltip';

const debouncedCreateExternalTooltip = debounce(
  (c, title, tooltipId, isMobile) => externalTooltipHandler(c, title, tooltipId, isMobile),
  50,
);

export const useChartModel = ({ labels, data: dataset, title, color, colorFill, isMobile }) => {
  const [tooltipId] = useState(uuidv4());

  if (labels.length === 1 && dataset.length === 1) {
    // это для того, чтобы показывалась линия на графике, когда у нас одна точка
    labels.push(labels[0]);
    dataset.push(dataset[0]);
  }

  const options = useMemo(() => {
    const { format } = new Intl.NumberFormat('fr-FR', {
      minimumFractionDigits: 2,
    });
    return {
      plugins: {
        legend: {
          display: false,
        },
        datalabels: {
          display: false,
        },

        tooltip: {
          enabled: false,
          external: c => {
            debouncedCreateExternalTooltip(c, title, tooltipId, isMobile);
          },
        },
      },

      scales: {
        x: {
          grid: {
            borderColor: axisGridColor,
            borderWidth: 3,
            color: ticksColor,
          },
          ticks: {
            color: ticksColor,
          },
        },
        y: {
          grid: {
            borderColor: axisGridColor,
            borderWidth: 3,
            color: ticksColor,
          },
          ticks: {
            color: ticksColor,
            callback: label => {
              return format(label);
            },
          },
        },
      },

      responsive: /* isMobile */ true,
      /* maintainAspectRatio: !isMobile, */
      aspectRatio: isMobile ? 1 : 2,
    };
  }, [tooltipId, title, isMobile]);

  const data = useMemo(
    () => ({
      labels,

      datasets: [
        {
          type: 'line',
          data: dataset,
          borderColor: color || '#FFFFFF80',
          borderWidth: 3,
          backgroundColor: colorFill || 'rgb(169, 172, 77, 0.3)',
          fill: true,
          pointRadius: 40,
          pointHoverRadius: 45,
          pointBorderColor: 'rgba(0, 0, 0, 0)',
          pointBackgroundColor: 'rgba(0, 0, 0, 0)',
          pointLabels: false,
        },
      ],
    }),
    [labels, dataset, color, colorFill],
  );

  return { data, labels, options };
};
